function ItemService(apiService) {
  this.removeItem = function(item) {
    const itemId = item.publicId;

    return apiService.paramAuth.get(`/item/${itemId}/remove`);
  };
}

ItemService.$inject = ['apiService'];

module.exports = ItemService;
